import { ActionItemInterface } from '../../interfaces/account-center/ActionItemInterface';
export class AccountCenterTableCell {
  policyLabel: string;
  private isCanceled: boolean;
  constructor(
    private style,
    public dataText: string,
    public actionItem?: ActionItemInterface,
    public tooltipText?: string,
    public toolTipClass?: string
  ) {}

  getClasses() {
    const cssClassNames = {
      'account-center-table__cell': true,
    };

    if (this.isCanceled) {
      cssClassNames['account-center-table__cell--canceled'] = true;
    }

    cssClassNames[`account-center-table__cell--${this.style}`] = true;

    return cssClassNames;
  }

  setPolicyLabel(label: string) {
    this.policyLabel = label;
  }

  setCanceled(isCanceled: boolean) {
    this.isCanceled = isCanceled;
  }
}
